module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"reset_password.title":"รีเซ็ตรหัสผ่าน","reset_password.ok":"รีเซ็ต","field.username":"ชื่อผู้ใช้งาน","field.new_password":"รหัสผ่านใหม่","field.new_password.placeholder":"กรุณาระบุรหัสผ่านใหม่ของผู้ใช้งานนี้","field.new_password.hint":"@:common.password.pattern","field.password.err.pattern":"@:common.password.pattern"}}')
  delete Component.options._Ctor
}
